import { styled } from "../theme";
export const SideMenu = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;
`;
